import type { InputHTMLAttributes } from 'react';

import React, { forwardRef } from 'react';

import { useForwardRef } from '../../hooks/use-forward-ref';
import { classNames } from '../../utils/class-names';

import styles from './text-input.module.css';

export type TextInputProps = InputHTMLAttributes<HTMLInputElement>;

export const TextInput = forwardRef<HTMLInputElement, TextInputProps>(
  ({ className, style, disabled, placeholder, children, ...props }, ref) => {
    const inputRef = useForwardRef(ref);

    if (children) {
      return (
        <div
          role="none"
          className={classNames(
            styles.wrapper,
            styles.input,
            disabled && styles.disabled,
            props.readOnly && styles.readOnly,
            className
          )}
          style={style}
        >
          <input
            ref={inputRef}
            type="text"
            className={styles.baseInput}
            placeholder={disabled ? '' : placeholder}
            disabled={disabled}
            {...props}
          />
          {children}
        </div>
      );
    }

    return (
      <input
        ref={inputRef}
        type="text"
        className={classNames(styles.baseInput, styles.onlyInput, className)}
        style={style}
        placeholder={disabled ? '' : placeholder}
        disabled={disabled}
        {...props}
      />
    );
  }
);
